export const settings = {
    jisti: {
        user: 'moderador',
        password: 'moderador@2020'
    }
}
